import type { FunctionComponent } from 'react';

import Flex from '../Flex';
import { registerIcon } from '../Icon';
import * as nineDotIcon from '../Icon/icons/dot-9-solid.icon';
import MenuButton from '../MenuButton';
import { useI18n } from '../../hooks';
import type { ForwardProps } from '../../types';

import { StyledContextSwitcher } from './AppHeader.styles';
import type { ContextSwitcherProps } from './AppShell.types';

registerIcon(nineDotIcon);

const ContextSwitcher: FunctionComponent<ContextSwitcherProps & ForwardProps> = ({
  contexts,
  onContextClick,
  label,
  ...restProps
}) => {
  const t = useI18n();

  return (
    <Flex container={{ justify: 'center' }} as={StyledContextSwitcher} {...restProps}>
      <MenuButton
        text={label ?? t('switch_to')}
        variant='simple'
        icon='dot-9-solid'
        iconOnly
        menu={{
          mode: 'single-select',
          items: contexts,
          onItemClick: onContextClick
        }}
      />
    </Flex>
  );
};

export default ContextSwitcher;
